import { LOGIN_SOURCE_IFRAME } from '@cont/Login/constants';

const isIframeLogin = (query) => {
  const isIframe = window.self !== window.top;
  const container = window.top;
  return (
    isIframe &&
    query.is_iframe_login &&
    query.source === LOGIN_SOURCE_IFRAME &&
    container.location?.href?.includes('unacademy.com') &&
    container.postMessage
  );
};

export default isIframeLogin;
